import React, { useState, useEffect } from "react";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";
import MghDetails from "./profileComponent/MghDetails";

const Details = () => {
  const [neurostampId, setNeurostampId] = useState("");

  useEffect(() => {
    getMGHDetails();
  }, []);

  const getMGHDetails = () => {
    let neurostamp_id = localStorage.getItem("neurostamp_id");
    if (neurostamp_id.length === 0) {
      return;
    }
    setNeurostampId(neurostamp_id);
  };

  return (
    <div className="view-speech-demographics-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10 main-section add-user top-space"
          style={{ marginLeft: "auto" }}
        >
          <br />
          <br />
          <a href="/participants/speech" className="go-back">
            <i className="fas fa-chevron-left"></i>
          </a>
          <div className="wrapper clearfix">
            <div className="multisteps-form mgh-details-form">
              <div className="row">
                <div className="col-12 col-lg-12 pl-0">
                  <div className="wizard-content-form">
                    <div className="wizard-form-field">
                      {neurostampId ? (
                        <MghDetails neurostamp_id={neurostampId} />
                      ) : (
                        <p
                          style={{
                            textAlign: "center",
                            marginTop: 20,
                            marginBottom: 20,
                            fontSize: 24,
                          }}
                        >
                          Data is not available..
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
